import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGetPreSearchGoods, apiGetSelectLikeGoods } from '../api';
import AppBar from '../components/appBar';
import Empty from '../components/empty';
import HighlightedText from '../components/highlightedText';
import Page from '../components/page';
import main from '../main';
import { Goods } from '../types';
import { buildLandingHomePath, readLandingSearchHistory, readLandingSearchParams } from '../utils/landingPage';
import { cloneDeep, showToast } from '../utils/utils';

export default function SearchPage() {
  let navigate = useNavigate();
  let uc = main.uc;

  let list = readLandingSearchHistory();

  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const searchRequestIdRef = useRef(0);
  // 搜索商品列表
  const [goodsList, setGoodsList] = useState<Goods[]>([]);
  // 猜你喜欢商品列表
  const [linkGoodsList, setlinkGoodsList] = useState<Goods[]>([]);
  // 历史记录-展开/收起
  const [isShowMore, setisShowMore] = useState<boolean>(false);
  const [searchVal, setsearchVal] = useState<string>('');
  const [isNullData, setisNullData] = useState<boolean>(false);
  // 历史记录
  const [historyList, sethistoryList] = useState<Goods[]>(list ?? []);

  useEffect(() => {
    let value = sessionStorage.getItem('searchIptValue');
    if (!!value) {
      setsearchVal(value);
      fetchData(value);
    }
    getSelectLikeGoods();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null; // 清空引用，避免内存泄漏
      }
    };
  }, []); // eslint-disable-line

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setsearchVal(value); // 更新输入值状态

    if (timerRef.current) {
      clearTimeout(timerRef.current); // 清除未执行的旧定时器
    }
    if (!value.trim()) {
      searchRequestIdRef.current += 1;
      setGoodsList([]);
      setisNullData(false);
      return;
    }
    // 0.3秒后执行接口调用
    timerRef.current = setTimeout(() => {
      fetchData(value);
    }, 300);
  };

  const fetchData = async (value: string) => {
    if (!value.trim()) return;
    const requestId = ++searchRequestIdRef.current;
    try {
      let res = await apiGetPreSearchGoods({ goodsName: value, shopId: main.shopId });
      let data = res.data;
      if (requestId !== searchRequestIdRef.current) return;
      if (data.code === 200) {
        const rows = data.data ?? [];
        setGoodsList(rows);
        setisNullData(rows.length === 0);
      } else {
        setGoodsList([]);
        setisNullData(true);
      }
    } catch (error) {
      if (requestId === searchRequestIdRef.current) {
        setGoodsList([]);
        setisNullData(true);
      }
    }
  };

  async function getSelectLikeGoods() {
    try {
      let res = await apiGetSelectLikeGoods();
      let data = res.data;
      if (data.code === 200) {
        setlinkGoodsList(data.data ?? []);
      }
    } catch (e) {}
  }

  async function getSearchGoods() {
    setisNullData(false);
    if (!searchVal) {
      showToast('请输入要搜索的内容');
      return;
    }
    sessionStorage.setItem('searchIptValue', searchVal);
    let _param = readLandingSearchParams();
    _param.mobileNet = 'all';
    sessionStorage.setItem('searchParams', JSON.stringify(_param));
    window.location.replace(landingHomePath);
  }
  function toDetailView(code: string) {
    navigate('/product?id=' + code + `${uc ? '&uc=' + uc : ''}`, { state: 'search' });
  }
  async function toView(item: Goods) {
    if (list.find((i: Goods) => i?.id === item?.id)) {
      toDetailView(item?.goodsCode);
    } else {
      toDetailView(item?.goodsCode);
      list.push({ id: item?.id, goodsCode: item?.goodsCode, goodsName: item?.goodsName });
    }
    if (list.length > 10) {
      list = list.slice(-10); // 保留最后10个元素，前面的元素被删除
    }
    sethistoryList(list);
    localStorage.setItem('searchList', JSON.stringify(list));
  }
  function handleRemove() {
    localStorage.removeItem('searchList');
    sethistoryList([]);
  }
  let _flipHistoryList = cloneDeep(historyList ?? []);
  let flipHistoryList: Goods[] = _flipHistoryList.reverse();
  const landingHomePath = buildLandingHomePath({ code: main.shopId, from: main.from, uc });
  return (
    <Page
      className="search-page d-flex-c"
      contentClassName="flex-1 h-1 d-flex-c"
      style={{
        background: 'url("/pic/pic_page_bg_new.png")',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#f1f1f1',
      }}
      appBar={
        <AppBar
          showBack
          onBack={() => {
            navigate(-1);
          }}
          className="bg-transparent"
          title="筛选商品"
        />
      }
    >
      <div className="search-ipt-block d-flex-r bg-white pl-10 pr-3 pt-5 pb-5 m-10 border-radius-8 pos-r">
        <input
          className="input-block flex-1"
          type="text"
          placeholder="输入关键字搜索您想要的商品"
          value={searchVal}
          onChange={handleInputChange}
        />
        <div className="pos-a r-2 t-3 d-flex-r ai-center">
          {!!searchVal && (
            <img
              className="w-20 h-20"
              src="/pic/icon_clear.png"
              alt=""
              onClick={(e) => {
                e.stopPropagation();
                setsearchVal('');
                searchRequestIdRef.current += 1;
                setGoodsList([]);
                setisNullData(false);
                sessionStorage.removeItem('searchIptValue');
              }}
            />
          )}
          <span
            className="search-btn ml-5 text-color-white pt-3 pb-3 pl-10 pr-10 border-radius-8"
            onClick={getSearchGoods}
          >
            搜 索
          </span>
        </div>
      </div>
      <div className="content-block flex-1 bg-white pl-12 pr-12 pt-20 pb-20 overflow-y">
        {!searchVal && (
          <>
            {flipHistoryList.length > 0 && (
              <div className="mb-20">
                <div className="d-flex-r ai-center jc-between mb-10">
                  <div className="font-size-16 font-widget-500 ">历史搜索</div>

                  <div className="d-flex-r ai-center">
                    <div className="d-flex-r ai-center mr-15">
                      {flipHistoryList.length > 3 && (
                        // <span
                        //   className="text-color-6 mr-3 border pl-8 pr-8 border-radius-16"
                        //   style={{ borderColor: '#666' }}
                        //   onClick={() => setisShowMore(!isShowMore)}
                        // >
                        //   {!isShowMore ? '展开' : '收起'}
                        // </span>
                        <div
                          className="d-flex-r ai-center pl-6 pr-6 border border-radius-16"
                          style={{ borderColor: '#999' }}
                        >
                          <img
                            className="w-20 h-20"
                            onClick={() => setisShowMore(!isShowMore)}
                            src={`/pic/icon_${!isShowMore ? 'search_up' : 'search_shout'}.png`}
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                    {flipHistoryList.length > 3 && <div className="w-2 h-20 bg-ccc mr-15"></div>}
                    {flipHistoryList.length >= 1 && (
                      <img className="w-20 h-20" src="/pic/icon_remove.png" alt="" onClick={handleRemove} />
                    )}
                  </div>
                </div>
                <div className="history-block d-flex-r flex-wrap">
                  {flipHistoryList.map((item, idx) => (
                    <div key={item.id} onClick={() => toDetailView(item?.goodsCode)}>
                      {idx <= 2 && (
                        <div className="history-item mr-10 omit-text-1 pl-5 pr-5 mb-5 line-height-30 text-color-3">
                          {item?.goodsName}
                        </div>
                      )}
                      {idx > 2 && isShowMore && (
                        <div className="history-item mr-10 omit-text-1 pl-5 pr-5 mb-5 line-height-30 text-color-3">
                          {item?.goodsName}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="mb-20">
              <div className="font-size-16 font-widget-500 text-color-0">猜你想搜</div>
              <div className="d-flex-c mt-10">
                {linkGoodsList.map((item) => (
                  <div key={item.id} className="mb-5 line-height-30 text-color-3" onClick={() => toView(item)}>
                    {item?.goodsName}
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
        {searchVal && isNullData && <Empty />}
        {searchVal && !isNullData && (
          <div>
            {goodsList.map((item) => (
              <div key={item.id} className="history-item pl-5 pr-5 mb-5 text-color-3" onClick={() => toView(item)}>
                <HighlightedText text={item.goodsName} searchTerm={searchVal} />
              </div>
            ))}
          </div>
        )}
      </div>
    </Page>
  );
}
